export class StorageAdapter {
  constructor(private readonly storage: Storage) {}

  getItem<T>(key: string): T | string | null {
    const value = this.storage.getItem(key);
    try {
      return value !== null ? (JSON.parse(value) as T) : null;
    } catch {
      return value;
    }
  }

  setItem(key: string, input: Dictionary | string): void {
    const value: string =
      input instanceof Object ? JSON.stringify(input) : input;
    this.storage.setItem(key, value);
  }

  removeItem(key: string): void {
    return this.storage.removeItem(key);
  }
}
